import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class BrasilApiService {
  constructor(private http: HttpClient) { }
  //Api Fellipe Dechamps
  // private link: string = 'https://brasilapi.com.br/api/banks/v1';
  private apiUrl = 'https://olinda.bcb.gov.br/olinda/servico/CCR/versao/v1/odata/Instituicoes';
  // getBancos(): Observable<any>{
  //   return this.http.get(this.link);
  // }
  getBanks(): Observable<any> {
    // Filtrando para obter apenas bancos (se necessário, ajuste o filtro conforme a API)
    const filter = '$filter=Pais eq `Brasil`';
    return this.http.get(`${this.apiUrl}?${filter}`);
  }
}
